(ns teamoesterreich.admin-mode.administration.organisation.organisation-list
  (:require ["react-virtualized" :as rv]
            [clojure.string :as string]
            [clojure.string]
            [reagent.core :as r]
            [teamoesterreich.view-state :as v-state]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.admin-mode.administration.organisation.organisation-form :as org-form]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.refresh :refer [refresh]]
            ))






(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))

(defn level-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span
       (case cell-data
         "1" (txt/txt :rights-level 1)
         "2" (txt/txt :rights-level 2)
         "3" (txt/txt :rights-level 3)
         "?"
         )
       ])))


(defn edit-cell-renderer [!selected]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        (if (d-rights/allow-admin-for d-rights/ADMIN_ORG cell-data)
          [mui/icon-button {:title   (str "bearbeiten " cell-data)
                            :onClick #(reset! !selected cell-data)
                            } [edit {:fontSize "small"}]]

          "")))))


(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !selected (r/cursor !st [:selected])
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !show-inactive (r/cursor !st [:show-inactive])
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          height
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection")) :invalidated true))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "OrganisationList"}
         ;(log/debug "rerender " m " @!show-inactive " @!show-inactive " @!sort " @!sort " @!reverse " @!reverse rows)

         [:> rv/Column
          {:label        "#"
           :dataKey      (name :organisation-key)
           :className    "bordered exampleColumn"
           :cellRenderer (edit-cell-renderer !selected)
           :width        70}]


         [:> rv/Column
          {:label     "Art"
           :dataKey   (name :organisation-key)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     120}]

         [:> rv/Column
          {:label        "Typ"
           :dataKey      (name :organisation-level)
           :cellRenderer level-cell-renderer
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :width        120}]


         [:> rv/Column
          {:label     (txt/txt :rights-level 1)
           :dataKey   (name :_organisationMain)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     120}]

         [:> rv/Column
          {:label     (txt/txt :rights-level 2)
           :dataKey   (name :_organisationDepartment)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     120}]

         [:> rv/Column
          {:label     (txt/txt :rights-level 3)
           :dataKey   (name :organisation-name)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     200}]
         [:> rv/Column
          {:label     "Email"
           :dataKey   (name :organisation-email)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     300}]


         (when (> width 1200)
           [:> rv/Column
            {:label     "Lebensretter Email"
             :dataKey   (name :organisation-lrEmail)
             :className "bordered exampleColumn"
             :style     #js {:overflow "hidden" :textAlign "left"}
             :width     250}])
         (when (> width 1200)
           [:> rv/Column
            {:label     "Tafel Email"
             :dataKey   (name :organisation-tafelEmail)
             :className "bordered exampleColumn"
             :style     #js {:overflow "hidden" :textAlign "left"}
             :width     250}])

         [:> rv/Column
          {:label        "Plz"
           :dataKey      (name :organisation-zip)
           :cellRenderer (fn [p] (string/join "," (sort (or (get (js->clj p) "cellData") []))))
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :width        250}]

         ]))))


(defn enrich-data-fn [entry dep-list org-list]
  (let [mask (str (:organisation-key entry))
        entry (merge entry
                     [:_organisationDepartment (or (get dep-list mask)
                                                   (reduce (fn [c [m n]]
                                                             ;(log/debug "find dep m:" m " t:" mask)
                                                             (if (re-matches (re-pattern m) mask) n c)) "-" dep-list))]
                     [:_organisationMain (or (get org-list mask)
                                             (reduce (fn [c [m n]]
                                                       ;(log/debug "find dep m:" m " t:" mask)
                                                       (if (re-matches (re-pattern m) mask) n c)) "-" org-list))]
                     )]
    ;(log/debug "enrich-data-fn " (clj->js entry) (clj->js dep-list))
    entry
    ))

(defn filter-fn [data !st]
  (let [org-filter-pattern (re-pattern (or (get-in @!st [:filter :regFilter-organizationDepartment]) (get-in @!st [:filter :regFilter-organizationMain]) ".*"))]
    (log/debug "filter-fn " (count data) (:search @!st) (clj->js org-filter-pattern))
    (filter (fn [[k e]] (and
                          ; inactive
                          (or (:show-inactive @!st) (not= (:organisation-active e) false))
                          ;:organisationDepartment
                          (re-matches org-filter-pattern (str (:organisation-key e)))

                          ;search
                          (re-find (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split (:search @!st) " ")))
                                   (str (:_organisationDepartment e) "#" (:organisation-name e)))))
            data)))

(defn update-list [!st dep-list org-list]
  (h/update-table-list !st d-organisation/<get-organisation-list {:filter-fn filter-fn :default-sort :organisation-key :data-walk-fn (fn [entry] (enrich-data-fn entry dep-list org-list))}))




(defn get-table [!st !rows]
  (fn [] [:> rv/AutoSizer
          {:style {:backgroundColor "red"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st @!rows)]))


(defn get-it []
  (let [!st (r/atom {:rows {} :loaded nil :create-modal-show nil})
        !sort (r/cursor !st [:sort])
        !reverse (r/cursor !st [:sort])]
    (fn []
      (js/console.log "Mount org-map sort:" (clj->js @!sort) "  reverse:" (clj->js @!reverse))
      (let [!create-modal (r/cursor !st [:create-modal-show])
            !create-warning (r/cursor !st [:create-modal-warning])
            !invalidated (r/cursor !st [:invalidated])
            !show-inactive (r/cursor !st [:show-inactive])
            !selected (r/cursor !st [:selected])
            !search (r/cursor !st [:search])
            !filter (r/cursor !st [:filter])
            !loaded? (r/cursor !st [:loaded])
            !rows (r/cursor !st [:rows])
            !waiting? (r/cursor !st [:waiting])

            !organisations (r/cursor v-state/app-state [:organisations])
            org-mask-list (or (d-organisation/get-main-filter-list @!organisations) [])
            dep-mask-list (or (d-organisation/get-lv-filter-list @!organisations) [])
            ]
        (update-list !st dep-mask-list org-mask-list)
        (if (not @!loaded?)
          (do
            [:div {:style {:marginTop "100px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  loading..."])
          (if @!selected
            [(org-form/get-it !selected !loaded?)]


            [mui/paper
             [create-with-name-modal/modal
              !create-modal
              "Bitte gib eine Dienststellennummer für die neue Dienststelle ein"
              "Erstellen"
              (fn [key]
                (if (d-rights/allow-admin-for d-rights/ADMIN_ORG key)
                  (do
                    (log/debug "Create news with key: " key)
                    (d-organisation/>organisation-new key
                                                      (fn [_]
                                                        (reset! !create-warning nil)
                                                        (reset! !loaded? false)
                                                        (reset! !selected key)
                                                        )))
                  (reset! !create-warning "\n !!! Ungültige Nummer !!!   Du musst das Recht für den Block haben!"))
                )
              nil
              !create-warning
              ]
             [mui/grid
              {:container  true
               :direction  "row"
               :alignItems "stretch"
               :justify    "flex-start"
               :spacing    1
               :style      {:marginTop "15px" :height "calc(100% - 20px)" :minHeight "400px"}
               }
              [mui/grid
               {:item true
                :md   3
                :xs   3
                }
               (when (d-rights/allow-admin-for d-rights/ADMIN_ORG)
                 [mui/button {:startIcon (r/as-element [add]) :color "secondary" :variant "outlined" :style {:margin "5px 40px 5px 0"}
                              :onClick   #(reset! !create-modal true)
                              }
                  "Neue Dienststelle"])]

              [mui/grid
               {:item true
                :md   8
                :xs   7
                :type {:textAlign "bottom"}
                }
               [mui/typography {:variant "h5" :padding "5px 0 0 0"} " Dienststellen Liste "]
               ]
              [mui/grid
               {:item true
                :md   1
                :xs   2
                }
               [ws-event-sync-component/ws-event-reload !loaded? :organisation]]

              [mui/grid
               {:item true
                :md   4
                :xs   3
                }

               [mui/text-field
                {:default-value   (str @!search)
                 :label           "Suche"
                 :fullWidth       true
                 :placeholder     "Suche in Liste ..."
                 :InputLabelProps {:disableAnimation true :shrink true}
                 :style           {:display "inline-block"}
                 :onChange        (h/wait-do !waiting? (fn [e] (reset! !search e) (reset! !invalidated true)))
                 :multiline       false}]
               ]
              [mui/grid
               {:item true
                :md   4
                :xs   6
                }
               [org-selector/get-selector-org !filter (fn [] (reset! !invalidated true)) (d-rights/get-rights-orgId-filter d-rights/ADMIN)]
               ]
              [mui/grid
               {:item  true
                :md    4
                :xs    3
                :style {:text-align "right"}
                }
               [mui/radio-group {:row true :class "filterRadio" :style {:float "right"}}

                [mui/form-control-label {:label   "Nicht aktive einblenden" :value "dst" :placement "start"

                                         :control (r/as-element [mui/checkbox {:checked  (or @!show-inactive false)
                                                                               :onChange (fn [_ val]
                                                                                           (reset! !show-inactive val)
                                                                                           (reset! !invalidated true)
                                                                                           )
                                                                               }])}]]

               ]

              [mui/grid
               {:item  true
                :xs    12
                :style {:height "calc(100% - 50px)"}
                }
               [get-table !st !rows]
               ]

              [mui/grid
               {:item true
                :xs   12
                }

               [mui/button {:style   {:verticalAlign "center" :margin "0px 0 7px 10px"}
                            :variant "outlined"
                            :onClick #(d-organisation/csv-list)
                            } "CSV"]
               ]
              ]

             ]))
        ))))









